module.exports = __webpack_public_path__ + "img/research-information.6c17ad27.png";